import type { TableColumn } from '@consta/uikit/Table'
import type { WellId } from 'common/types'

import { titleCellRender } from '../../table'
import type { OnChangeVspOffsetFunc } from '../../types'
import { VspOffset } from '../VspOffset'
import type { RowWellVsp } from './types'
import { VspName } from './VspName'
import { WellNameCell } from './WellNameCell'

export const getWellsTableColumns = (
  hasNextStep: boolean,
  hoveredRowId: string | undefined,
  checkedWells?: Set<WellId>,
  onCheck?: (wellId: WellId) => void,
  onChangeVspOffset?: OnChangeVspOffsetFunc,
): TableColumn<RowWellVsp>[] => {
  const showShift = onChangeVspOffset !== undefined
  return [
    {
      title: titleCellRender('Скважина'),
      accessor: 'wellName',
      width: showShift ? 215 : 320,
      renderCell: ({ id, wellName }) => {
        const chosen = checkedWells?.has(id)
        return <WellNameCell wellId={id} wellName={wellName} chosen={chosen} onCheck={onCheck} />
      },
    },
    {
      title: titleCellRender('Сдвиг, мс'),
      withoutPadding: true,
      accessor: 'offset',
      align: 'center',
      hidden: !showShift,
      renderCell: ({ projectVspId, offset, id }) =>
        !!projectVspId && (
          <VspOffset
            offset={offset ?? undefined}
            onOffset={onChangeVspOffset?.(projectVspId, id)}
          />
        ),
    },
    {
      withoutPadding: true,
      title: titleCellRender('Активный скоростной закон'),
      accessor: 'vspName',
      width: 280,
      renderCell: ({ id, vspName }) => (
        <VspName vspName={vspName} isArrow={hasNextStep} isVisible={id === hoveredRowId} />
      ),
    },
  ]
}
